module.exports = __webpack_public_path__ + "img/3-1.e038ebff.png";